export const IS_WEBKIT = typeof window.webkitConvertPointFromNodeToPage === 'function'
